import script from "./FileInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./FileInput.vue?vue&type=script&lang=ts&setup=true"

import "./FileInput.vue?vue&type=style&index=0&id=cdb026e2&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdb026e2"]])

export default __exports__